import { CrashScreen } from '@/components/layout/CrashScreen'
import { COMPANION_PATH, CompanionPage } from '@/pages/CompanionPage'
import { CustomerDisplayPage } from '@/pages/CustomerDisplayPage'
import { AppProviders } from '@/providers/AppProviders'
import { configService } from '@/services'
import { CUSTOMER_DISPLAY_PATH } from '@/services/customerDisplay'

import { AppRoutes } from './AppRoutes'

// The tenant is resolved from the host (the store's POS domain); on localhost, VITE_CLIENT_HOST names it.
const host = window.location.hostname
const isLocalhost = host === 'localhost' || host === '127.0.0.1'
// Dev server opened from a phone on the LAN (http://192.168.x.x:port): same tenant as localhost, and an API on this
// machine's localhost is reached through the same LAN address.
const isLanDev = import.meta.env.DEV && /^(10|192\.168|172\.(1[6-9]|2\d|3[01]))\./.test(host)
const baseUrl = isLanDev ? import.meta.env.VITE_API_BASE_URL?.replace(/\/\/(localhost|127\.0\.0\.1)(?=[:/]|$)/, `//${host}`) : import.meta.env.VITE_API_BASE_URL

// Token and system uid are set by SessionProvider.
configService.setConfig({
  apiConfig: {
    baseUrl,
    clientHost: (isLocalhost || isLanDev) && import.meta.env.VITE_CLIENT_HOST ? import.meta.env.VITE_CLIENT_HOST : host,
  },
})

// The customer display window and a companion run none of the till (session, sync, device database).
const App = () =>
  window.location.pathname === CUSTOMER_DISPLAY_PATH ? (
    <CustomerDisplayPage />
  ) : window.location.pathname === COMPANION_PATH ? (
    <CompanionPage />
  ) : (
    <CrashScreen>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </CrashScreen>
  )

export default App
